<template>
    <div class="card">
        <template v-if="metrics && metrics.length">
            <div class="grid flex">
                <div class="xl:col-6 md:col-12 sm:col-12" v-for="metric in metrics" :key="metric.id">
                    <!-- <div class="card"> -->
                    <!--
                    <StaticMetric :metric="metric" />
                    -->
                    <MetricGraph :graphData="metric" :default-months="3" class="card" />
                </div>
            </div>
        </template>
        <template v-else>
            <div class="col-12">
                <div class="px-4 py-8 md:px-6 lg:px-8 text-center">
                    <div class="mb-3 font-bold text-2xl">
                        <span class="text-900"> No Metrics Data available in the dashboard </span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script setup>

import { ref, onMounted } from 'vue';
import useUserComposable from '@/composables/UserComposable';
import GlobalRequest from '@/api/global-request';
import MetricGraph from '@/products/pha/modules/dashboard/components/MetricGraph.vue';

const { getAllUsers } = useUserComposable();

onMounted(() => {});

const metrics = ref(null);


onMounted(async () => {

    const { company_id } = useUserComposable();

    GlobalRequest.getRequest('v2/datasource/dashboard', {
        params: {
            company_id: company_id.value,
            page_size: 1,
            page: 1,
            paginate: 1,
        }
    }).then((response) => {
        if (response.statusCode === 200) {
            if (Object.hasOwn(response, 'data')) {

                if (Object.hasOwn(response.data, 'data')) {
                    const [homepage] = response.data?.data;

                    if (typeof homepage !== 'undefined' && Object.hasOwn(homepage, 'details')) {

                        metrics.value = [];

                        homepage.details.forEach((detail) => {

                            //console.log('detail', detail)

                            if (detail.metric_id != null && detail.metric_id > 0) {
                                metrics.value.push({
                                    id: detail.metric_id,
                                    type: 'metric',
                                })
                            } else if (detail.usergroups_id != null && detail.usergroups_id > 0) {

                                metrics.value.push({
                                    id: detail.usergroups_id,
                                    type: 'userGroup',
                                })
                            }else if (detail.s_usergroups_id != null && detail.s_usergroups_id > 0) {

                                metrics.value.push({
                                    id: detail.s_usergroups_id,
                                    type: 'specialUserGroup',
                                })
                            }


                        });
                    }
                }
            }
        }
    });

    /*
    // Manually adding metric ids for now for static dashboard
    if (company_id.value === 39) {
        metrics.value = [
            { metric_id: 5, chart: true, type: 'bar', userCountFlag: true },
            { metric_id: 16, chart: true, type: 'bar', userCountFlag: true },
            { metric_id: 24, chart: true, type: 'bar' },
            { metric_id: 9, chart: false },
            { metric_id: 10, chart: false },
        ];
    } else if (company_id.value === 22) {
        metrics.value = [
            { metric_id: 1, chart: true, type: 'line' },
            { metric_id: 3, chart: true, type: 'bar' },
            { metric_id: 4, chart: true, type: 'line' },
            { metric_id: 5, chart: true, type: 'line' },
            { metric_id: 6, chart: true, type: 'line' },
            { metric_id: 9, chart: true, type: 'bar' },
        ];
    }
    */
    await loadUsers();
});

const loadUsers = async () => {
    await getAllUsers({});
};
</script>
